import { InvitationCollectionItem, InvitationCollectionSendBulkData } from '../types/invitation-tracker.type'
import { resolveInvitationChannelBlockedSendState } from './invitation-channel-blocked-send.util'
import { getInvitationChannelLatestStatus, InvitationChannel, isInvitationChannelAvailable } from './invitation-channel-status.util'

/**
 * Builds a bulk-send summary from loaded selected items (before-send check when nobody can be invited).
 * Maps missing channel contact info and blocked reasons into count fields shown by the summary modal.
 */
export function buildBulkSendSummaryFromItems(items: InvitationCollectionItem[], channel: InvitationChannel): InvitationCollectionSendBulkData {
  let invited_count = 0
  let declined_count = 0
  let opt_out_count = 0
  let registered_count = 0
  let unreachable_count = 0
  let bounced_count = 0
  let failed_count = 0
  let no_contact_info = 0

  for (const item of items) {
    if (!isInvitationChannelAvailable(item, channel)) {
      no_contact_info += 1
      continue
    }

    const reason = resolveInvitationChannelBlockedSendState({
      actionTaken: item.action_taken,
      channel,
      channelLatestStatus: getInvitationChannelLatestStatus(item, channel),
      isOptOut: item.is_opt_out
    }).reason

    switch (reason) {
      case 'declined':
        declined_count += 1
        break
      case 'opt_out':
        opt_out_count += 1
        break
      case 'registered':
        registered_count += 1
        break
      case 'unreachable':
        unreachable_count += 1
        break
      case 'channel_bounced':
        bounced_count += 1
        break
      case 'channel_failed':
      case 'event_ended':
        failed_count += 1
        break
      default:
        invited_count += 1
        break
    }
  }

  return { invited_count, declined_count, opt_out_count, registered_count, no_contact_info, unreachable_count, bounced_count, failed_count }
}
